<template>
    <DxDataGrid :data-source="dsTemeiuriLegale" ref="dataGridRef" :allow-column-reordering="false" :allow-column-resizing="true" :column-auto-width="false"
        :show-borders="true" key-expr="Id">
        <DxSelection mode="single" />
        <DxFilterRow :visible="false" />
        <DxPaging :page-size="10" :page-index="0" />
        <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
        <DxSorting mode="multiple" />
        <DxSearchPanel :visible="true" :width="240" placeholder='Cauta ...'></DxSearchPanel>
        <DxEditing :allow-updating="true" :allow-deleting="true" mode="popup">
            <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" width="370" height="330" :show-title="true" title-template="editTitle">
                <DxToolbarItem toolbar="bottom" widget="dxButton" location="center" :options="saveButtonOptions" />
                <DxToolbarItem toolbar="bottom" widget="dxButton" location="center" :options="dangerButtonOptions" />
            </DxPopup>
            <DxFormGrid :col-count="2">
                <DxItem data-field="name" :editor-options="{ height: 50 }"/>
                 <DxItem 
                    data-field="inOut" 
                    editor-type="dxSelectBox"
                    :editor-options="{ 
                        items: inOutOptions, 
                        displayExpr: 'text', 
                        valueExpr: 'id',
                        placeholder: 'Selectati tipul...',
                        height: 50
                    }"
                />
                <DxItem data-field="CodRevisal" :editor-options="{ height: 50 }"/>
                <DxItem data-field="Explicatie" :editor-options="{ height: 50 }"/>
            </DxFormGrid>
        </DxEditing>
        <template #editTitle>
            <div style="background-color:#ff2c21; font-size:15px; color:white; font-weight:bold; padding:10px 0 10px 20px; width:100%;">
                Editare Temei Legal
            </div>
        </template>

        <DxColumn data-field="name" caption="Nume"/>
        <DxColumn data-field="inOut" caption="Tip" cell-template="tipTemplate"/>
        <DxColumn data-field="CodRevisal" caption="Cod Revisal"/>
        <DxColumn data-field="Explicatie" caption="Explicatie"/>
        <template #tipTemplate="{ data }">
            <div v-if="data.value==='I'">Angajare</div>
            <div v-if="data.value==='O'">Plecare</div>
            <div v-if="data.value==='R'">Reintegrare</div>
            <div v-if="data.value==='S'">Suspendare</div>
        </template>

        <DxToolbar>
            <DxItem location="after" name="searchPanel"/>
            <DxItem>
                <template #default>
                    <DxButton icon="add" type="success" @click="onAddClick" />
                </template>
            </DxItem>
            <DxItem>
                <template #default>
                    <DxButton icon="refresh" @click="onRefreshClick" />
                </template>
            </DxItem>
        </DxToolbar>
    </DxDataGrid>
    <DxPopupAdd :visible="addPopupVisible" :show-title="true" width="370" height="330">
        <template #title>
            <div style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
                Adăugare Temei Legal
            </div>
        </template>
        <DxForm :col-count="2" :data-dource="newTemeiLegal">
            <DxSimpleItem data-field="Nume" :is-required="true">
                <template #default>
                    <DxTextArea :value="newTemeiLegal.name" @value-changed="onNumeValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="In/Out" :is-required="true">
                <template #default>
                    <!-- <DxTextArea :value="newTemeiLegal.inOut" @value-changed="onInOutValueChanged" height="50px"/> -->
                     <DxSelectBox 
                        :items="inOutOptions"
                        display-expr="text"
                        value-expr="id"
                        :value="newTemeiLegal.inOut"
                        @value-changed="onInOutValueChanged"
                        height="50px"
                    />
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Cod Revisal">
                <template #default>
                    <DxTextArea :value="newTemeiLegal.CodRevisal" @value-changed="onCodRevisalValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Explicatie">
                <template #default>
                    <DxTextArea :value="newTemeiLegal.Explicatie" @value-changed="onExplicatieValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
        </DxForm>
        <DxToolbarItem widget="dxButton" toolbar="bottom" location="center" :options="addButtonOptions"/>
        <DxToolbarItem widget="dxButton" toolbar="bottom" location="center" :options="closeButtonOptions"/>
    </DxPopupAdd>
</template>
<script lang="ts">
    import {
        DxColumn,
        DxDataGrid,
        DxFilterRow,
        DxLoadPanel,
        DxPaging,
        DxSelection,
        DxSorting,
        DxStateStoring,
        DxToolbar,
        DxEditing,
        DxPopup,
        DxItem,
        DxItem as DxFormItem,
        DxForm as DxFormGrid,
        DxValidationRule,
        DxRequiredRule,
        DxSearchPanel,
    } from 'devextreme-vue/data-grid';
    import DxDateBox from 'devextreme-vue/date-box';
    import { DxCheckBox } from 'devextreme-vue/check-box';
    import DxTextArea from 'devextreme-vue/text-area';
    import AppSetting from '@/settings/appSettings';
    import { defineComponent, ref } from 'vue';
    import DataSource from 'devextreme/data/data_source';
    import { DxButton } from 'devextreme-vue/button';
    import notify from 'devextreme/ui/notify';
    import { DxForm, DxSimpleItem } from "devextreme-vue/form"
    import DxPopupAdd from 'devextreme-vue/popup'
    import { DxToolbarItem } from 'devextreme-vue/popup';
    import { DxNumberBox } from "devextreme-vue/number-box";
    import { DxSelectBox } from 'devextreme-vue/select-box';
    import PER_EmploymentTypes from '@/services/PER/PER_EmploymentTypes';

    export default defineComponent({
        components: {
            DxColumn,
            DxDataGrid,
            DxFilterRow,
            DxLoadPanel,
            DxPaging,
            DxSelection,
            DxSorting,
            DxStateStoring,
            DxToolbar,
            DxEditing,
            DxValidationRule,
            DxRequiredRule,
            DxItem,
            DxButton,
            DxSearchPanel,
            DxForm,
            DxPopupAdd,
            DxSimpleItem,
            DxTextArea,
            DxCheckBox,
            DxToolbarItem,
            DxPopup,
            DxFormGrid,
            DxFormItem,
            DxDateBox,
            DxNumberBox,
            DxSelectBox
        },
        data() {
            return {
                dsTemeiuriLegale: {} as DataSource,
                dataGridRef: ref<DxDataGrid | null>(null),
                deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
                addPopupVisible: false,
                newTemeiLegal: {
                    name: '',
                    inOut: '',
                    CodRevisal: null,
                    Explicatie: null,
                },
                addButtonOptions: {
                    type: "success", 
                    text: "Salvează", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.onSaveAdd()
                    }
                },
                saveButtonOptions: {
                    type: "success", 
                    text: "Salvează", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.onSaveEdit()
                    }
                },
                closeButtonOptions: {
                    type: "danger", 
                    text: "Închide", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.onCloseAdd()
                    }
                },
                dangerButtonOptions: {
                    type: "danger", 
                    text: "Închide", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.closeEditPopup()
                    }
                },
                inOutOptions: [
                    { id: 'I', text: 'Angajare' },
                    { id: 'O', text: 'Plecare' },
                    { id: 'R', text: 'Reintegrare' },
                    { id: 'S', text: 'Suspendare' }
                ],
            }
        },
        mounted() {
            this.dsTemeiuriLegale = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ResurseUmaneOdata + `PER_EmploymentTypes`,
                    key: 'Id',
                    keyType: 'Guid',
                    version: 4,
                    beforeSend: (e: any) => {
                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                        };
                    },
                },
            })
            this.dataGridRef = this.$refs.dataGridRef as DxDataGrid;
            this.setDeleteConfirmationMessage()
        },
        methods: {
            setDeleteConfirmationMessage() {
                const dataGrid = this.$refs.dataGridRef?.instance;
                dataGrid.option('editing', {
                    allowUpdating: true,
                    allowDeleting: true,
                    mode: 'popup',
                    texts: {
                        confirmDeleteMessage: this.deleteConfirmationMessage,
                        confirmDeleteTitle: "Confirmare Ștergere",
                    }
                });
            },
            onRefreshClick() {
                const gridInstance = this.dataGridRef?.instance;
                if (gridInstance) {
                    gridInstance.refresh();
                    notify("Datele au fost actualizate cu succes!", "success", 3000);
                }
            },
            onAddClick() {
                this.addPopupVisible = true
            },
            onCloseAdd() {
                this.addPopupVisible = false
                this.newTemeiLegal.name = ''
                this.newTemeiLegal.inOut = ''
                this.newTemeiLegal.CodRevisal = null
                this.newTemeiLegal.Explicatie = null
            },
            onSaveAdd() {
                if (!this.newTemeiLegal.name || this.newTemeiLegal.name.trim() === "") {
                    notify("Vă rog să completați câmpul 'Nume'!", "error", 3000)
                    return
                }

                if (!this.newTemeiLegal.inOut) {
                    notify("Vă rog să selectați câmpul 'In/Out'!", "error", 3000)
                    return
                }

                PER_EmploymentTypes.save(this.newTemeiLegal).then((temei) => {
                    this.addPopupVisible = false
                    notify('Datele au fost salvate cu succes!', 'success', 2000)
                    this.newTemeiLegal = {
                        name: '',
                        inOut: '',
                        CodRevisal: null,
                        Explicatie: null
                    }
                    this.onRefreshClick()
                }).catch((error) => {
                    console.error(error)
                })
            },
            onNumeValueChanged(e: any) {
                this.newTemeiLegal.name = e.value
            },
            onInOutValueChanged(e: any) {
                this.newTemeiLegal.inOut = e.value
            },
            onCodRevisalValueChanged(e: any) {
                this.newTemeiLegal.CodRevisal = e.value
            },
            onExplicatieValueChanged(e: any) {
                this.newTemeiLegal.Explicatie = e.value
            },
            closeEditPopup() {
                this.dataGridRef?.instance?.cancelEditData();
            },
            async onSaveEdit() {
                const gridInstance = this.dataGridRef?.instance;
                if (!gridInstance) {
                    notify('Eroare: Grila nu este încărcată.', 'error', 2000);
                    return; 
                }
                try {
                    gridInstance.saveEditData()
                    
                } catch (error: any) {
                    console.error("Eroare la salvarea editării:", error);
                }
            },
        }
    })
</script>